interface CircularIconProps {
  onClick?: () => void
  icon?: React.ReactNode
}

export default function CircularIcon({ icon, onClick }: CircularIconProps) {
  return (
    <span
      className='w-10 h-10 grid place-content-center cursor-pointer rounded-full bg-gray-50 curposor-pointer'
      onClick={onClick}
    >
      <figure>{icon}</figure>
    </span>
  )
}
